import clsx from 'clsx'

export type SideNavFooterProps = {
  /** Content to render in the footer (typically account menu, support links) */
  children: React.ReactNode
  /** Additional className */
  className?: string
}

/**
 * Footer section of the SideNav that's pinned to the bottom.
 *
 * Used for:
 * - Account menu
 * - Support links
 * - Sign in button (for anonymous users)
 */
export function SideNavFooter({ children, className }: SideNavFooterProps) {
  return <div className={clsx('flex flex-col flex-1 justify-end', className)}>{children}</div>
}
